import uniqid from "uniqid";
import Vue from "vue";

const forceJson = (val) => {
  let result = {};
  if (val) {
    result = JSON.parse(JSON.stringify(val));
  }
  return result;
};

const getFullLink2 = (link, siteUrl = "", fromLanding = false) => {
  if (link) {
    if (link === "#") return link;
    if (link.startsWith("/")) return `${siteUrl}${link}`;
    if (fromLanding && link.startsWith("#")) return `${siteUrl}/${link}`;
    if (!fromLanding && link.startsWith("#")) return link;
    if (!link.startsWith("http")) return `https://${link}`;
  }
  return link;
};
const generateSectionId = () => {
  return `section-${uniqid()}`;
};
const generateRowId = () => {
  return `row-${uniqid()}`;
};
const generateColumnId = () => {
  return `column-${uniqid()}`;
};
const generateElementId = (prefix = "") => {
  if (prefix) return `${prefix}-${uniqid()}`;
  return `element-${uniqid()}`;
};
const isLegacy = (referenceObject, blog) => {
  if (!referenceObject || !blog) {
    return true;
  }
  if (
    referenceObject.hasOwnProperty("key") &&
    referenceObject.key === "DigitalMarketing"
  ) {
    return true;
  }
  if (
    referenceObject.hasOwnProperty("template_key") &&
    referenceObject.template_key === "DigitalMarketing"
  ) {
    return true;
  }
  // New visual editor sites are never treated as legacy blog posts
  if (referenceObject.is_new_editor) {
    return false;
  }
  if (
    blog.sections &&
    blog.sections.length &&
    blog.builderOptions &&
    Object.keys(blog.builderOptions).length
  ) {
    return false;
  }
  return true;
};
const isValidUrl = (value) => {
  const matchPattern = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
  return matchPattern.test(value);
};
const isValidEmail = (value) => {
  const matchPattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return matchPattern.test(value);
};
const findIndex = (array, key, value) => {
  let index = -1;
  for (let i = 0; i < array.length; i++) {
    if (array[i][key] === value) {
      index = i;
      break;
    }
  }
  return index;
};
const capitalizeFirstChar = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};
const checkSingleOption = (key, options) => {
  return options && options[key] && options[key].show;
};
const getButtonOption = (sectionKey, option, buttonSample) => {
  let returnData = {};
  const sample = {
    ...buttonSample,
    BackgroundColor: option.ButtonBackground,
    TextColor: option.ButtonColor,
    SubTextColor: option.ButtonColor,
    BorderColor: option.ButtonBorderColor,
    CustomLink: option.ButtonLink || "",
    OpenInNewWindow: option.OpenInNewWindow || false,
    Text: option.ButtonText || option.ButtonLabel || "",
  };
  let sampleCopy = JSON.parse(JSON.stringify(sample));
  if (sectionKey === "aboutFull") {
    sampleCopy.FontSize = "20";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "header") {
    sampleCopy.FontSize = "14";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "banner") {
    sampleCopy.Alignment = option.Align || "left";
    sampleCopy.FontSize = "20";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "banner2" || sectionKey === "bannerForm") {
    sampleCopy.FontSize = "20";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "bannerFeature") {
    sampleCopy.SubText = option.ButtonHelper;
    sampleCopy.FontSize = "30";
    sampleCopy.SubFontSize = "14";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "calltoaction") {
    sampleCopy.Alignment = "center";
    sampleCopy.FontSize = "20";
    sampleCopy.ImageAlignment = "center";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "trialFeature") {
    sampleCopy.SubText = option.ButtonHelper;
    sampleCopy.Alignment = "center";
    sampleCopy.FontSize = "28";
    sampleCopy.SubFontSize = "14";
    sampleCopy.ImageAlignment = "center";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "contact") {
    sampleCopy.Text = "Submit";
    sampleCopy.Alignment = "center";
    sampleCopy.LinkDisabled = true;
    sampleCopy.FontSize = "14";
    sampleCopy.ImageAlignment = "center";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "services") {
    sampleCopy.Alignment = "center";
    sampleCopy.FontSize = "20";
    sampleCopy.ImageAlignment = "center";
    returnData.Button1 = sampleCopy;
    if (option.Items && option.Items.length) {
      option.Items.forEach((item, index) => {
        sampleCopy = JSON.parse(JSON.stringify(sample));
        sampleCopy.Text = item.ButtonText || "Learn more";
        sampleCopy.BackgroundColor = option.ItemButtonBackground;
        sampleCopy.TextColor = option.ItemButtonColor;
        sampleCopy.SubTextColor = option.ItemButtonColor;
        sampleCopy.BorderColor = option.ItemButtonBorderColor;
        sampleCopy.PageId = item.PageId || "";
        sampleCopy.Alignment = "center";
        sampleCopy.FontSize = "14";
        sampleCopy.ImageAlignment = "center";
        returnData[`SubButton${index + 1}`] = sampleCopy;
      });
    }
  } else if (sectionKey === "servicesFounder") {
    if (option.Items && option.Items.length) {
      option.Items.forEach((item, index) => {
        let sampleCopy = JSON.parse(JSON.stringify(sample));
        sampleCopy.Text = "Learn more";
        sampleCopy.PageId = item.PageId || "";
        sampleCopy.Alignment = "center";
        sampleCopy.FontSize = "14";
        sampleCopy.ImageAlignment = "center";
        returnData[`SubButton${index + 1}`] = sampleCopy;
      });
    }
  } else if (sectionKey === "title") {
    sampleCopy.Alignment = option.ButtonAlign;
    sampleCopy.FontSize = "20";
    sampleCopy.ImageAlignment = "center";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "articles") {
    sampleCopy.Text = "Read more";
    sampleCopy.LinkDisabled = true;
    sampleCopy.FontSize = "14";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "location") {
    sampleCopy.Alignment = "center";
    sampleCopy.FontSize = "20";
    sampleCopy.ImageAlignment = "center";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "podcast") {
    sampleCopy.PageId = "episodes";
    sampleCopy.FontSize = "14";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "button") {
    sampleCopy.Alignment = "center";
    sampleCopy.ImageAlignment = "center";
    returnData.Button1 = sampleCopy;
  } else if (sectionKey === "bannerTotal") {
    sampleCopy.Alignment = "left";
    sampleCopy.ImageAlignment = "left";
    returnData.Button1 = sampleCopy;
  }
  return returnData;
};
const videoType = (link) => {
  if (link.match(/^https:\/\/www\.youtube\.com/)) return "youtube";
  else if (link.match(/^https:\/\/vimeo.com/)) return "vimeo";
  return "video";
};
const videoSocail = (link) => {
  return videoType(link) === "youtube" || videoType(link) === "vimeo";
};
const videoSource = (link, autoPlay = true, extraOptions = {}) => {
  const vType = videoType(link);
  const aPlay = autoPlay ? 1 : 0;
  if (vType === "youtube") {
    let videoId = link.replace(/.*\?v=/, "").replace(/&.*/, "");
    return `https://www.youtube.com/embed/${videoId}?autoplay=${aPlay}&mute=1&controls=0&showinfo=0&loop=1`;
  } else if (vType === "vimeo") {
    let videoId = link.replace(/.*com\//, "");
    let url = `https://player.vimeo.com/video/${videoId}?autoplay=${aPlay}&background=${aPlay}&autopause=0&loop=1&byline=0&title=0&muted=1`;
    if (
      extraOptions &&
      extraOptions.vimeo &&
      Object.keys(extraOptions.vimeo).length
    ) {
      for (let i in extraOptions.vimeo) {
        url += `&${i}=${extraOptions.vimeo[i]}`;
      }
    }
    return url;
  }
  return link;
};
const videoSourceUpgraded = (link, extraOptions = {}) => {
  const vType = videoType(link)
  const autoPlay = extraOptions.AutoPlay ? 1 : 0
  const loop = extraOptions.Loop ? 1 : 0
  const controls = extraOptions.ShowControls ? 1 : 0

  if (vType === 'youtube') {
    // Match watch?v=, youtu.be/, or shorts/
    const match = link.match(/(?:v=|\/shorts\/|youtu\.be\/)([^&?/]+)/)
    const videoId = match ? match[1] : null
    if (!videoId) return link // fallback if parsing fails

    return `https://www.youtube.com/embed/${videoId}?autoplay=${autoPlay}&mute=1&controls=${controls}&showinfo=0&playlist=${videoId}&loop=${loop}`
  }
  if (vType === 'vimeo') {
    const videoId = link.replace(/.*com\//, '')
    return `https://player.vimeo.com/video/${videoId}?autoplay=${autoPlay}&autopause=0&loop=${loop}&controls=${controls}&byline=0&title=0&muted=1`
  }
  return link
}

const getParentDOM = (child, className) => {
  if (child.classList && child.classList.contains(className)) {
    return child;
  }
  let node = child.parentNode;
  while (node !== null) {
    if (node.classList && node.classList.contains(className)) {
      return node;
    }
    node = node.parentNode;
  }
  return null;
};
const makeString = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};
const getSocialLinksFromSettingsNE = (settings) => {
  const items = [];
  const socials = settings.socials;
  if (socials.Facebook) {
    items.push({
      Name: "Facebook",
      Icon: "facebook-square",
      Link: socials.Facebook,
      OpenInNewWindow: true,
    });
  }
  if (socials.LinkedIn) {
    items.push({
      Name: "LinkedIn",
      Icon: "linkedin-square",
      Link: socials.LinkedIn,
      OpenInNewWindow: true,
    });
  }
  if (socials.Instagram) {
    items.push({
      Name: "Instagram",
      Icon: "instagram",
      Link: socials.Instagram,
      OpenInNewWindow: true,
    });
  }
  if (socials.YouTube) {
    items.push({
      Name: "YouTube",
      Icon: "youtube",
      Link: socials.YouTube,
      OpenInNewWindow: true,
    });
  }
  if (socials.Twitter) {
    items.push({
      Name: "Twitter",
      Icon: "x-twitter",
      Link: socials.Twitter,
      OpenInNewWindow: true,
    });
  }
  if (socials.Google) {
    items.push({
      Name: "Google",
      Icon: "google",
      Link: socials.Google,
      OpenInNewWindow: true,
    });
  }
  return items;
};
const allowedPremiumElements = (config, user) => {
  if (user) {
    if (user.role !== "Admin" && user.agency) {
      return user.agency.premiumElements;
    }
    if (user.role === "Admin" && config && config.allPremiumElements) {
      return config.allPremiumElements;
    }
  }
  return [];
};
const isPremiumElement = (config, elementKey) => {
  if (config && config.allPremiumElements) {
    return config.allPremiumElements.includes(elementKey);
  }
  return false;
};
const isAllowedElement = (user, config, elementKey) => {
  return (
    !isPremiumElement(config, elementKey) ||
    allowedPremiumElements(config, user).includes(elementKey)
  );
};
const isAllowedApp = (user, appKey) => {
  if (user) {
    if (user.role === "Admin") {
      return true;
    }
    if (user.role !== "Admin" && user.agency) {
      return user.agency.premiumApps.includes(appKey);
    }
  }
  return false;
};
const findUserLanding = (user, landingId) => {
  let found = {};
  if (user && user.userLandings && user.userLandings.length) {
    user.userLandings.every((userLanding) => {
      if (userLanding.landing_id === landingId) {
        found = userLanding;
        return false;
      }
      return true;
    });
  }
  return found;
};
const getAllowedPermissions = (user, config, landingId) => {
  let permissions = [];
  if (user && config) {
    if (["AgencyUser", "WebsiteUser"].includes(user.role)) {
      const userLanding = findUserLanding(user, landingId);
      permissions = userLanding.permissions || [];
    } else if (["CardUser"].includes(user.role)) {
      permissions = permissions.concat(user.userCards[0].permissions);
    } else {
      Object.keys(config.landingPermissions).forEach((permission) => {
        if (!permission.includes(".spacer")) {
          permissions.push(permission);
        }
      });
    }
  }
  return permissions;
};

const checkCardLimit = (user, landing) => {
  if (user && landing && landing.card_count >= landing.card_limit) {
    Vue.$toast.open({
      message:
        "You already reached the max card limit. Pleaes contact admin to increase.",
      type: "error",
    });
    return false;
  }
  return true;
};

const debounce = (fn, wait) => {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer); // clear any pre-existing timer
    }
    const context = this; // get the current context
    timer = setTimeout(() => {
      fn.apply(context, args); // call the function if time expires
    }, wait);
  };
};

const findNestedRowIndex = (sections2, selectedRowId) => {
  let foundIndices = {
    sessionIndex: -1,
    rowIndex: -1,
    columnIndex: -1,
    nestedRowIndex: -1,
  };

  Object.entries(sections2).forEach(([sessionIndex, section]) => {
    for (const rowIndex in section.rows) {
      const row = section.rows[rowIndex];

      for (const columnIndex in row.columns) {
        const column = row.columns[columnIndex];

        if (column?.rows !== undefined) {
          for (const nestedRowIndex in column.rows) {
            const nestedRow = column.rows[nestedRowIndex];
            if (nestedRow.id === selectedRowId) {
              foundIndices = {
                sessionIndex: Number(sessionIndex),
                rowIndex: Number(rowIndex),
                columnIndex: Number(columnIndex),
                nestedRowIndex: Number(nestedRowIndex),
              };
            }
          }
        }
      }
    }
  });
  return foundIndices;
};
const findNestedColumnIndex = (sections2, selectedColumnId) => {
  let foundIndices = {
    sessionIndex: -1,
    rowIndex: -1,
    columnIndex: -1,
    nestedRowIndex: -1,
    nestedColumnIndex: -1,
  };

  Object.entries(sections2).forEach(([sessionIndex, section]) => {
    for (const rowIndex in section.rows) {
      const row = section.rows[rowIndex];

      for (const columnIndex in row.columns) {
        const column = row.columns[columnIndex];

        if (column?.rows !== undefined) {
          for (const nestedRowIndex in column.rows) {
            const nestedRow = column.rows[nestedRowIndex];

            for (const nestedColumnIndex in nestedRow.columns) {
              const nestedColumn = nestedRow.columns[nestedColumnIndex];

              if (nestedColumn.id === selectedColumnId) {
                foundIndices = {
                  sessionIndex: Number(sessionIndex),
                  rowIndex: Number(rowIndex),
                  columnIndex: Number(columnIndex),
                  nestedRowIndex: Number(nestedRowIndex),
                  nestedColumnIndex: Number(nestedColumnIndex),
                };
              }
            }
          }
        }
      }
    }
  });
  return foundIndices;
};
const findNestedElementIndex = (sections2, selectedElementId) => {
  let foundIndices = {
    sessionIndex: -1,
    rowIndex: -1,
    columnIndex: -1,
    nestedRowIndex: -1,
    nestedColumnIndex: -1,
    nestedElementIndex: -1,
  };

  Object.entries(sections2).forEach(([sessionIndex, section]) => {
    for (const rowIndex in section.rows) {
      const row = section.rows[rowIndex];

      for (const columnIndex in row.columns) {
        const column = row.columns[columnIndex];

        if (column?.rows !== undefined) {
          for (const nestedRowIndex in column.rows) {
            const nestedRow = column.rows[nestedRowIndex];

            for (const nestedColumnIndex in nestedRow.columns) {
              const nestedColumn = nestedRow.columns[nestedColumnIndex];
              for (const nestedelementIndex in nestedColumn.elements) {
                const nestedElement = nestedColumn.elements[nestedelementIndex];
                if (nestedElement.id === selectedElementId) {
                  foundIndices = {
                    sessionIndex: Number(sessionIndex),
                    rowIndex: Number(rowIndex),
                    columnIndex: Number(columnIndex),
                    nestedRowIndex: Number(nestedRowIndex),
                    nestedColumnIndex: Number(nestedColumnIndex),
                    nestedElementIndex: Number(nestedelementIndex),
                  };
                }
              }
            }
          }
        }
      }
    }
  });
  return foundIndices;
};
const findColumnIndex = (sectionId, rowId, id, sections2 = null) => {
  let index = -1;
  const indexes = findRowIndex(sectionId, rowId, sections2);
  if (indexes[0] >= 0 && indexes[1] >= 0) {
    const sectionIndex = indexes[0];
    const rowIndex = indexes[1];
    if (sections2 !== null && Array.isArray(sections2)) {
      index = findIndex(
        sections2[sectionIndex].rows[rowIndex].columns,
        "id",
        id
      );
    } else {
      index = findIndex(
        sections2[sectionIndex].rows[rowIndex].columns,
        "id",
        id
      );
    }
  }
  indexes.push(index);
  return indexes;
};
const findRowIndex = (sectionId, id, sections2 = null) => {
  let index = -1;
  const sectionIndex = findSectionIndex(sectionId, sections2);
  if (sectionIndex >= 0) {
    if (sections2 !== null && Array.isArray(sections2)) {
      index = findIndex(sections2[sectionIndex].rows, "id", id);
    } else {
      index = findIndex(sections2[sectionIndex].rows, "id", id);
    }
  }
  return [sectionIndex, index];
};
const findSectionIndex = (id, sections2) => {
  return findIndex(sections2, 'id', id)
}
const replacePlaceholdersInJson = (json, replacements) => {
  const recurse = (obj) => {
    if (typeof obj === 'string') {
      return Object.keys(replacements).reduce((str, key) => {
        const pattern = new RegExp(`<\\*${key}\\*>`, 'g');
        return str.replace(pattern, replacements[key]);
      }, obj);
    }

    if (Array.isArray(obj)) {
      return obj.map(item => recurse(item));
    }

    if (typeof obj === 'object' && obj !== null) {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        acc[key] = recurse(value);
        return acc;
      }, {});
    }

    return obj;
  };

  return recurse(json);
};
const generateHoursTable = (days) => {
  const visible = days.filter(d => d.Show);
  const width = 100 / visible.length;

  const cells = visible.map(d => `
    <td style="vertical-align: top; width: ${width}%; word-break: break-all; border: none; padding: 0 5px;">
      <h6 style="color: #FFFFFF; margin-top: 0; text-align: center;">${d.Name}</h6>
      <p style="color: #FFFFFF; text-align: center;">${d.Hours}</p>
    </td>
  `).join('');

  return `<table style="width: 100%;"><tbody><tr>${cells}</tr></tbody></table>`;
};

const ensureSemanticHeadingTag = (html, tag) => {
  if (!html || !/^h[1-6]$/.test(tag)) {
    return html;
  }
  const trimmed = html.trim();
  const headingPattern = new RegExp(`^<${tag}(\\s[^>]*)?>.*</${tag}>$`, "is");
  if (headingPattern.test(trimmed)) {
    return trimmed;
  }
  const wrongHeadingMatch = trimmed.match(/^<(h[1-6])(\s[^>]*)?>(.*)<\/\1>$/is);
  if (wrongHeadingMatch) {
    return `<${tag}${wrongHeadingMatch[2] || ""}>${wrongHeadingMatch[3]}</${tag}>`;
  }
  const paragraphMatch = trimmed.match(/^<p(\s[^>]*)?>(.*)<\/p>$/is);
  if (paragraphMatch) {
    return `<${tag}${paragraphMatch[1] || ""}>${paragraphMatch[2]}</${tag}>`;
  }
  const divMatch = trimmed.match(/^<div(\s[^>]*)?>(.*)<\/div>$/is);
  if (divMatch) {
    return `<${tag}${divMatch[1] || ""}>${divMatch[2]}</${tag}>`;
  }
  return `<${tag}>${trimmed}</${tag}>`;
};
export {
  forceJson,
  getFullLink2,
  generateSectionId,
  generateRowId,
  generateColumnId,
  generateElementId,
  isLegacy,
  isValidUrl,
  isValidEmail,
  findIndex,
  capitalizeFirstChar,
  checkSingleOption,
  getButtonOption,
  videoType,
  videoSocail,
  videoSource,
  videoSourceUpgraded,
  getParentDOM,
  makeString,
  getSocialLinksFromSettingsNE,
  allowedPremiumElements,
  isPremiumElement,
  isAllowedElement,
  isAllowedApp,
  findUserLanding,
  getAllowedPermissions,
  checkCardLimit,
  debounce,
  findNestedColumnIndex,
  findNestedElementIndex,
  findNestedRowIndex,
  findColumnIndex,
  replacePlaceholdersInJson,
  generateHoursTable,
  ensureSemanticHeadingTag,
};
